import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-noosa',
  templateUrl: './noosa.component.html',
  styleUrls: ['./noosa.component.scss']
})
export class NoosaComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['noosa'];
  }

}
